import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { ComponentProps } from 'react';
import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalDescription,
  ModalTitle,
} from '../../../../../design-system/modal/modal';
import { SettingsModalContent } from './settings-modal-content';

type SettingsModalProps = {
  isOpen: boolean;
  excludedSendersConfig: ComponentProps<typeof SettingsModalContent>['excludedSendersConfig'];
  emailConnectionConfig: ComponentProps<typeof SettingsModalContent>['emailConnectionConfig'];
  xeroConnectionConfig: ComponentProps<typeof SettingsModalContent>['xeroConnectionConfig'];
  onClose: () => void;
};

export const SettingsModal = ({
  isOpen,
  excludedSendersConfig,
  emailConnectionConfig,
  xeroConnectionConfig,
  onClose,
}: SettingsModalProps) => {
  return (
    <Modal open={isOpen} onOpenChange={onClose}>
      <ModalContent className="h-max w-[520px] p-7">
        <VisuallyHidden>
          <ModalTitle>Invoice Pay Setting</ModalTitle>

          <ModalDescription>Invoice Pay Setting</ModalDescription>
        </VisuallyHidden>

        <ModalCloseButton onClick={onClose} aria-label="Close modal" />

        <SettingsModalContent
          excludedSendersConfig={excludedSendersConfig}
          emailConnectionConfig={emailConnectionConfig}
          xeroConnectionConfig={xeroConnectionConfig}
        />
      </ModalContent>
    </Modal>
  );
};
